export const taskKeys = {
    all: ["tasks"] as const,
    tasks: () => [...taskKeys.all] as const,
    task: (id: string) => [...taskKeys.all, id] as const,
  } as const;

